import { GroupFeaturesContext } from '@trinity/chat-components/containers/Chat';
import { useContext } from 'react';

export const useIsSmartRouting = () => {
  const features = useContext(GroupFeaturesContext);
  return features.smartRouting;
};